import { createContext, useState } from 'react'
import { WithChildren } from '_metronic/helpers'

interface IContext {
  isOpenImportProjectModal: boolean
  toggleImportProjectModal: (isOpen: boolean) => void
  isOpenExportDailyReportModal: boolean
  toggleExportDailyReportModal: (isOpen: boolean) => void
}

export const ProjectListViewContext = createContext<IContext>({
  isOpenImportProjectModal: false,
  toggleImportProjectModal: () => {},
  isOpenExportDailyReportModal: false,
  toggleExportDailyReportModal: () => {},
})

export const ProjectListViewContextProvider: React.FC<WithChildren> = ({ children }) => {
  const [isOpenImportProjectModal, setIsOpenImportProjectModal] = useState(false)
  const [isOpenExportDailyReportModal, setIsOpenExportDailyReportModal] = useState(false)

  const toggleImportProjectModal = (isOpen: boolean) => {
    setIsOpenImportProjectModal(isOpen)
  }

  const toggleExportDailyReportModal = (isOpen: boolean) => {
    setIsOpenExportDailyReportModal(isOpen)
  }

  return (
    <ProjectListViewContext.Provider
      value={{
        isOpenImportProjectModal,
        toggleImportProjectModal,
        isOpenExportDailyReportModal,
        toggleExportDailyReportModal,
      }}>
      {children}
    </ProjectListViewContext.Provider>
  )
}
